<template>
  <div>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <h2>Tags</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="show=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider color="#42a5f5"></v-divider>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="tags"

        >
          <template v-slot:item="props">
            <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}" @click="showTagTransactions(props.item)" >
              <td style="text-align: center" v-for="(header, index) in headers" :key="index"
                  v-if="header.value !== 'actions'">{{props.item[header.value]}}

              </td>
              <td v-else style="text-align: center">
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="justify-center">
            <v-btn text color="blue-grey lighten-2" @click="show=false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showTransactions" width="70%">
    <v-card>
      <v-card-title>
        <h2>Tags Transactions</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="showTransactions=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider color="#42a5f5"></v-divider>
      <v-card-text>
        <v-container fluid class="pa-0">
          <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
            <v-col cols="9" sm="9" md="3">
              <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
            </v-col>
            <div style="display: flex; justify-content: center; align-items: center">
              <v-btn text @click="refresh" v-if="!isVisible">
                <v-icon color="cyan darken-2">refresh</v-icon>
              </v-btn>
              <div v-if="isVisible" class="load-3">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
              </div>
            </div>
            <v-col cols="9" sm="9" md="3"></v-col>
          </v-row>
        </v-container>
        <v-data-table
          :headers="headerTransactions"
          :items="renderedTagsTransactions"
          :search="search"
        >
        </v-data-table>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text color="blue-grey lighten-2" @click="showTransactions=false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>

</template>

<script>
  import axios from "axios";

  export default {
    name: "TagsDialog",
    props: {
      tags: Array,
      showProp: Boolean
    },
    data() {
      return {
        showTransactions:false,
        loading: false,
        reload: false,
        isVisible: false,
        timer: '',
        search: '',
        tag_id:null
      }
    },
    methods:{
      updateDataTable() {
        this.reload = !this.reload;
      },
      refresh() {
        setTimeout(() => this.isVisible = false, 1000);
        this.isVisible = true;
        this.reload = !this.reload;
      },
      showTagTransactions(item){
        if(this.isInternalUser && item.transaction == 'delivery'){
          this.showTransactions = true;
          this.tag_id = item.id;
        }
      }
    },
    mounted: function () {
      this.timer = setInterval(() => {
        this.reload = !this.reload;
      }, 300000)
    },
    beforeDestroy () {
      clearInterval(this.timer)
    },
    computed: {
      show: {
        get() {
          return this.showProp;
        },
        set(value) {
          if (!value) this.$emit('close');
        }
      },
      headers() {
        return [
          {text: 'Id', value: 'id', align: 'center', sortable: true},
          {text: 'Type', value: 'type', align: 'center', sortable: false},
          {text: 'Consolidation Depot Name', value: 'consolidation_depot_name', align: 'center', sortable: false},
          {text: 'Consolidation Date', value: 'production_date', align: 'center', sortable: false},
          {text: 'Item', value: 'item', align: 'center', sortable: true},
          {text: 'Serial Number', value: 'number', align: 'center', sortable: true},
          {text: 'Quantity', value: 'quantity', align: 'center', sortable: false},
          {text: 'Received', value: 'received', align: 'center', sortable: false},
        ];
      },
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      headerTransactions(){
        let headersTransactions = [
            {text: 'Id', value: 'id', align: 'center', sortable: true},
            {text: 'Time', value: 'time', align: 'center', sortable: true},
            {text: 'Type', value: 'type_text', align: 'center', sortable: false},
            {text: 'Depot', value: 'depot_name', align: 'center', sortable: true},
            {text: 'Reason Code', value: 'reason_code', align: 'center', sortable: false}
          ];
       if(this.isInternalUser){
         headersTransactions.push({text: 'User Name', value: 'username', align: 'center', sortable: true},);
       }
        return headersTransactions;
      },
      renderedTagsTransactions(){
        if (this.tagsTransactions === null || this.tagsTransactions === undefined) {
          return [];
        } else {
          // this.tagsTransactions.filter(
          //   (transactions) =>{
          //     transactions.date = transactions.time.date;
          //   }
          // );
          return this.tagsTransactions;
        }
      }
    },
    asyncComputed: {
      async tagsTransactions() {
        if(this.tag_id){
          if (this.reload || !this.reload){
            this.loading = true;
            return await axios.get(process.env.API_URL + '/tags/' + this.tag_id + '/transactions')
              .then((response) => {
                if (response.status === 200) {
                  this.loading = false;
                  return response.data;
                } else {
                  this.loading = false;
                  return [];
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
              });
          }
        }

      }
    },
  }
</script>

<style scoped>

>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/TagsDialog.vue